import axios from 'axios';

export default {
    methods: {
        api_loginzustand_url() {
            return this.server_base_url()
            + "/api/login/status";
        },
        api_loginzustand_feststellen() {
          let url = this.api_loginzustand_url();
          console.log("Ich stelle den Loginzustand fest mit url " + url);
          axios.post(url)
            .then(
              response => {
                let is_logged_in = response.data.is_logged_in;
                console.log(response.data);
                console.log("is_logged_in ist " + is_logged_in);
                console.log("loginzustand sagt dass token gueltig ist");
              }
            )
            .catch(
              () => {
                console.log("login/status sagt dass kein gueltiges Token da ist -> push nach /login");
                this.$router.push("/login");              
              }
            );
        },
        setze_access_token_aus_localstorage_in_axios_header() {
            console.log("Ich setze access_token in axios.headers.common");
            axios.defaults.headers.common["Authorization"] = localStorage.getItem('access_token');
        }
    }
}


